import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getBiDataForTierLink } from '../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import TierPromotionCard from '../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../TierPromotionCardWithFellaTooltip';
import s from './Tier.scss';
const TierFeedCardContents = ({ deviation, width, className, showTierPromotionTooltip })=>{
    const biData = getBiDataForTierLink(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, showTierPromotionTooltip ? /*#__PURE__*/ React.createElement(TierPromotionCardWithFellaTooltip, {
        deviation: deviation,
        width: width,
        isPostsFeedCard: true
    }) : /*#__PURE__*/ React.createElement(TierPromotionCard, {
        deviation: deviation,
        width: width
    }), /*#__PURE__*/ React.createElement(BiLink, {
        className: s['link-overlay'],
        biData: biData,
        href: Url.userSubscriptionsPath({
            username: deviation.author.username,
            tierDeviationId: deviation.deviationId,
            tierContentType: 'deviations'
        })
    }, /*#__PURE__*/ React.createElement("span", null)));
};
TierFeedCardContents.displayName = 'TierFeedCardContents';
export default TierFeedCardContents;

//# sourceMappingURL=Tier.js.map